function checkForAuthenticatedBotToken(app, authenticatedBotHeaders) {
  if (app && app.ctx && app.ctx.req) {
    const { headers } = app.ctx.req;
    // eslint-disable-next-line no-restricted-syntax, no-unused-vars
    for (const header of authenticatedBotHeaders) {
      if (headers[header]) return headers[header];
    }
  }

  return null;
}
export default checkForAuthenticatedBotToken;
